import { type Component, Show } from 'solid-js'
import { VIEWER_COUNT_THRESHOLD } from '~/lib/site'

type Props = {
  count: number
  connected: boolean
}

/**
 * いま同じ放送を見ている人数。
 *
 * 数人だと寂しく見えるので、一定人数に届くまでは表示しない。
 */
export const ViewerCount: Component<Props> = (props) => (
  // 接続できるまでは 0 が一瞬見えてしまうので、繋がってから出す
  <Show when={props.connected && props.count >= VIEWER_COUNT_THRESHOLD}>
    <span
      class="inline-flex items-center gap-1 text-[11px] text-ch-muted tabular"
      title="いま834CHを見ている人数"
    >
      <svg viewBox="0 0 16 16" class="size-3 fill-current" aria-hidden="true">
        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 1.5c-3 0-5.5 1.6-5.5 3.6V14h11v-.9c0-2-2.5-3.6-5.5-3.6Z" />
      </svg>
      {props.count.toLocaleString('ja-JP')}
    </span>
  </Show>
)
